// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__5z8WZ","title":"BackImages_title__1b46X","images":"BackImages_images__15ARz"};